<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-sidenav-container class="appcontent-container" autosize>
  <mat-sidenav #sidenav mode="side" [(opened)]="isSidebarOpen" class="appbarmenu-container">
    <div class="sidenav-content-wrapper">
      @if (permissions) {
      <mat-toolbar class="sidenav-header">
        <a class="nolink" [routerLink]="['/']">
          <div class="cssLayoutRowStartCenter">
            <mat-icon class="icon-35px" svgIcon="ic_crucible_steamfitter"></mat-icon>
            <h2 class="icon-text">Administration</h2>
          </div>
        </a>
      </mat-toolbar>
      <mat-list class="appitems-container">
        @if (canViewScenarioTemplateList()) {
        <mat-list-item [ngClass]="getSelectedClass(scenarioTemplatesText)" id="wrapper showhand"
          (click)="adminGotoScenarioTemplates()">
          <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-view-list"></mat-icon>
          {{ scenarioTemplatesText }}
          <button [attr.aria-label]="scenarioTemplatesText" mat-icon-button class="pull-right">
            <mat-icon fontIcon="mdi-menu-right"></mat-icon>
          </button>
        </mat-list-item>
        }
        @if (canViewScenarioList()) {
        <mat-list-item [ngClass]="getSelectedClass(scenariosText)" id="wrapper showhand" (click)="adminGotoScenarios()">
          <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-playlist-play"></mat-icon>
          {{ scenariosText }}
          <button [attr.aria-label]="scenariosText" mat-icon-button class="pull-right">
            <mat-icon fontIcon="mdi-menu-right"></mat-icon>
          </button>
        </mat-list-item>
        }
        @if (permissions.includes(SystemPermission.ViewUsers)) {
        <mat-list-item [ngClass]="getSelectedClass(usersText)" id="wrapper showhand" (click)="adminGotoUsers()">
          <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-account"></mat-icon>
          {{ usersText }}
          <button [attr.aria-label]="usersText" mat-icon-button class="pull-right">
            <mat-icon fontIcon="mdi-menu-right"></mat-icon>
          </button>
        </mat-list-item>
        }
        @if (permissions.includes(SystemPermission.ViewRoles)) {
        <mat-list-item [ngClass]="getSelectedClass(rolesText)" id="wrapper showhand" (click)="adminGotoRoles()">
          <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-lock"></mat-icon>
          {{ rolesText }}
          <button [attr.aria-label]="rolesText" mat-icon-button class="pull-right">
            <mat-icon fontIcon="mdi-menu-right"></mat-icon>
          </button>
        </mat-list-item>
        }
        @if (permissions.includes(SystemPermission.ViewGroups)) {
        <mat-list-item [ngClass]="getSelectedClass(groupsText)" id="wrapper showhand" (click)="adminGotoGroups()">
          <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-account-group"></mat-icon>
          {{ groupsText }}
          <button [attr.aria-label]="groupsText" mat-icon-button class="pull-right">
            <mat-icon fontIcon="mdi-menu-right"></mat-icon>
          </button>
        </mat-list-item>
        }
      </mat-list>
      }
      @if (!hideTopbar) {
      <img class="crucible-logo" alt="Crucible" [src]="
          (theme$ | async) === 'light-theme'
            ? 'assets/img/crucible-logo-light.png'
            : 'assets/img/crucible-logo-dark.png'
        " />
      }
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    @if (!hideTopbar) {
    <app-topbar [title]="showSection" [topbarView]="TopbarView.STEAMFITTER_ADMIN"></app-topbar>
    }
    @if (permissions) {
    <span>
      @if (
      showSection === scenarioTemplatesText &&
      canViewScenarioTemplateList()) {
      <app-admin-scenario-templates>
      </app-admin-scenario-templates>
      }
      @if (
      showSection === scenariosText &&
      canViewScenarioList()) {
      <app-admin-scenarios>
      </app-admin-scenarios>
      }
      @if (
      showSection === usersText &&
      permissions.includes(SystemPermission.ViewUsers)
      ) {
      <app-admin-users></app-admin-users>
      }
      @if (
      showSection === rolesText &&
      permissions.includes(SystemPermission.ViewRoles)
      ) {
      <app-admin-roles></app-admin-roles>
      }
      @if (
      showSection === groupsText &&
      permissions.includes(SystemPermission.ViewGroups)
      ) {
      <app-admin-groups></app-admin-groups>
      }
    </span>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
